import {
	QueryCapacityResponseBody,
	QueryCapacityRequestOptions,
	ReturnCapacityRequestOptions,
	UseCapacityRequestOptions,
} from '../services/capacity';
import { createAction } from '@reduxjs/toolkit';

// - Query Capacity

export const queryCapacityAction =
	createAction<{
		item: QueryCapacityRequestOptions['item'];
		resolve: (data: QueryCapacityResponseBody) => void;
		reject: (error: unknown) => void;
	}>('capacity/query');

export const resolveQueryCapacityAction = createAction<{
	data: QueryCapacityResponseBody;
	item: QueryCapacityRequestOptions['item'];
}>('capacity/query/resolve');

export const rejectQueryCapacityAction = createAction<{
	item: QueryCapacityRequestOptions['item'];
	error: unknown;
}>('capacity/query/reject');

// - Use Capacity

export const useCapacityAction =
	createAction<{
		item: UseCapacityRequestOptions['item'];
		quantity: UseCapacityRequestOptions['quantity'];
		resolve: (data: QueryCapacityResponseBody) => void;
		reject: (error: unknown) => void;
	}>('capacity/use');

// - Return Capacity

export const returnCapacityAction =
	createAction<{
		item: ReturnCapacityRequestOptions['item'];
		quantity: ReturnCapacityRequestOptions['quantity'];
		resolve: (data: QueryCapacityResponseBody) => void;
		reject: (error: unknown) => void;
	}>('capacity/return');

export const closeWarningBanner = createAction('capacity/closeWarningBanner');
